(function () {
	angular
		.module('trackeye')
		.factory('OLCoord', _OLCoordFactory);

	_OLCoordFactory.$inject = [];

	function _OLCoordFactory() {

		function OLCoord(coord) {
			this.lon = 0;
			this.lat = 0;
			this.radius = 0;

			// OL3 radius fix
			this.radius_scale = 1;

			this.setCoords(coord);
		}

		/**
		 * Return longitude
		 * @returns {number}
		 */
		OLCoord.prototype.getLon = function () {
			return this.lon;
		};

		/**
		 * Return latitude
		 * @returns {number}
		 */
		OLCoord.prototype.getLat = function () {
			return this.lat;
		};

		/**
		 * Return radius
		 * @returns {number}
		 */
		OLCoord.prototype.getRadius = function () {
			return this.radius;
		};

		OLCoord.prototype.hasLonLat = function () {
			return (
				angular.isDefined(this.lon) ||
				angular.isDefined(this.lat)
			) && (
				this.lon !== 0 ||
				this.lat !== 0
			);
		};

		/**
		 * Set the radius
		 * @param {number} radius
		 * @returns {OLCoord}
		 */
		OLCoord.prototype.setRadius = function (radius) {
			this.radius = angular.isDefined(radius) ? (radius * this.radius_scale) : this.radius;

			return this;
		};

		/**
		 * Returns coordinate
		 * @returns {ol.Coordinate}
		 */
		OLCoord.prototype.getCoord = function () {
			return this.proj('EPSG:4326', 'EPSG:3857');
		};

		/**
		 * Set coordinates and radius
		 * @param {number[]} coord
		 * @returns {OLCoord}
		 */
		OLCoord.prototype.setCoords = function (coord) {
			this.lon = angular.isDefined(coord[0]) ? coord[0] : this.lon;
			this.lat = angular.isDefined(coord[1]) ? coord[1] : this.lat;
			this.radius = angular.isDefined(coord[2]) ? (coord[2] * this.radius_scale) : this.radius;

			return this;
		};

		/**
		 * Transform to projection
		 * @param {string} from
		 * @param {string} to
		 * @returns {ol.Coordinate}
		 */
		OLCoord.prototype.proj = function (from, to) {
			return ol.proj.transform([this.getLon(), this.getLat()], from, to);
		};

		/**
		 * Method for returning a coord as the initial array
		 * @returns {number[]}
		 */
		OLCoord.prototype.toArray = function () {
			return [this.lon, this.lat, this.radius];
		};

		return OLCoord;
	}
})();